<template>
  <div class="x-scroll">
    <ul class="dots">
      <li :key="index" v-for="(title, index) of steps" :class="{fulfilled: step-1 > index, current: step-1 == index}">{{title}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    step: {default: 1},
    steps: {default: ['one', 'two']}
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/colors.scss';

.x-scroll {
  max-width: 100%;
  height: 100%;
  overflow-x: auto;

  // Hide scrollbar when possible
  -ms-overflow-style: none;
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar { // Chrome etc
    display: none;
  }
}

ul.dots {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  max-width: 1000px;
  margin: 1em auto;
  > li {
    display: block;
    position: relative;
    padding: 3em 2em 2em 1em;
    text-align: center;
    // Ensure each li takes the sme amount of space
    flex-basis: 0;
    flex-grow: 1;
  }
  > li::before {
    position: absolute;
    display: block;
    left: 50%;
    top: 1em;
    transform: translateX(-70%);
    content: "";
    width: 1.7em;
    height: 1.7em;
    background: white;
    border: 3px solid $red;
    border-radius: 50%;
    z-index: 9;
  }
  > li.current::before {
    background: $red;
  }
  > li.fulfilled::before {
    background: $red;
    color: white;
    content:"✓";
    line-height:1.6em;
  }
  > li::after {
    // Make a line to the right of each dot (except last)
    width: calc(100% - 5px);
    height: 2px;
    content: '';
    position: absolute;
    background-color: $red;
    left: calc(50% + 5px);
    top: calc(2em - 3px);
  }
  > li:last-child::after {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ProgressDots.vue